import langProjects from '../lang/';
import urlApis from '../apis/';
export default {
	langProjects: langProjects,
	urlApis: urlApis,
	access: false,
	asideStorage:[],
	lateralShow: true,
	refresh_list: 0,
	events_finished: 0,
	events_pending: 0,
}
